import {
    POS_SALES_BY_PRODUCT_SUCCESS,
    POS_SALES_BY_PRODUCT_LOADING

} from '../actions/SalesByProductAction';

const initialState = {
    salesByProductData: [],
    isLoading: true
};

const SalesByProductReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case POS_SALES_BY_PRODUCT_SUCCESS:
          return { ...state, salesByProductData: action.data, isLoading: false };
        case POS_SALES_BY_PRODUCT_LOADING:
          return { ...state, isLoading: action.isLoading };
        default:
          return state;
      }
};

export default SalesByProductReducer;
